import { toast } from "sonner";
import { Clock } from "@phosphor-icons/react";
import { useGet } from "@/hooks/useResource";
import { Loading, PageHeader, EmptyState } from "@/components/common";
import { Button } from "@/components/ui/button";

export default function RunningOrder() {
  const { data, loading } = useGet("/client/running-order");
  if (loading) return <Loading label="Loading running order" />;
  const timeline = data?.timeline || [];

  return (
    <div>
      <PageHeader eyebrow="On the Day" title="Running Order" description="The flow of your day, issued by the Gledswood team." />
      {timeline.length === 0 ? (
        <EmptyState icon={Clock} title="No running order yet" description="Your running order will appear here once Gledswood prepares it." />
      ) : (
        <ol className="max-w-3xl border-l border-secondary/50 ml-3 space-y-0" data-testid="running-order-timeline">
          {timeline.map((entry) => (
            <li key={entry.id} className="relative ml-6 border-b border-border py-5 last:border-0">
              <span className="absolute -left-[31px] top-7 h-3 w-3 rounded-full bg-secondary" />
              <div className="grid grid-cols-[5rem_1fr] gap-4">
                <time className="font-heading text-xl text-primary">{entry.time}</time>
                <div>
                  <h2 className="font-heading text-2xl text-primary">{entry.title}</h2>
                  {entry.description && <p className="mt-1 text-sm text-muted-foreground">{entry.description}</p>}
                </div>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
